import Fire_base from '../../Config/Fire_base'
import React, { useContext } from 'react'
import{AuthContex} from '../../contex/authContex'


const GetAuthCurrentUser = () => {
    const {currentUser} = useContext(AuthContex)
    const currentUserData= Fire_base.auth().currentUser
    
    if  (!currentUser) return false
    else  return currentUserData
     
}

export default GetAuthCurrentUser